import * as React from 'react';
import i18next from 'i18next';

interface ErrorProps {
    image: string;
    text: string;
}

class Error extends React.Component<any, ErrorProps> {

    render() {
        const {image, text} = this.props;
        return (
            <div className='container'>
                <div className='search-result__wrapper_error'>
                    <img src={image || require('../../../assets/no_requests.svg')} style={{width: '100%'}} />
                    <div className='search-result__group'>
                        <div className='not-found' style={{textAlign: 'center', margin: 0}}>{text || i18next.t('sorry_everything_will_work_soon')}</div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Error;



// WEBPACK FOOTER //
// ./src/components/Shared/NotFound/ErrorView.tsx